import { cloneDeep } from 'lodash';
import { getItemByKeyRecursive } from '@/components/Lists/lib';
import api from '@/api';

const researchModel = {
    state: {
        selectedWell: {},
        research: null,
        activeResearch: [],
        displayData: [],
        expandedKeys: [],
    },
    reducers: {
        setSelectedWell(state, payload) {
            return { ...state, selectedWell: payload };
        },
        setResearch(state, payload) {
            const { key, response } = payload || {};

            if (key) {
                const { research } = state;

                return {
                    ...state,
                    research: {
                        ...research,
                        [key]: response,
                    },
                };
            }

            return state;
        },
        setActiveResearch(state, payload) {
            if (!state.research) return { ...state };
            const activeResearch = state.research[payload];
            return { ...state, activeResearch };
        },
        setDisplayData(state, payload) {
            return { ...state, displayData: payload };
        },
        setExpandedKeys(state, payload) {
            return { ...state, expandedKeys: payload };
        },
    },
    effects: dispatch => ({
        setActiveWell(key, rootState) {
            const data = cloneDeep(rootState.lists.data);
            const result = getItemByKeyRecursive(data, key);

            dispatch.settingsResearch.setSelectedWell(result);
        },

        async loadResearch(items) {
            const result = Promise.allSettled(
                items.map(activeItem => {
                    const { id: wellId, key: activeKey } = activeItem;
                    return api.carottage
                        .fetchResearch(wellId)
                        .then(res => ({
                            response: res,
                            id: wellId,
                            key: activeKey,
                        }))
                        .catch(error => {
                            throw createError(error.message, { wellId });
                        });
                })
            );

            result.then(researches => {
                if (researches) {
                    researches.forEach(research => {
                        const { value } = research;

                        const modifiedResearch = value?.response?.map((item, idx) => {
                            item.children = item.children.map((c1, c1idx) => {
                                c1.children = c1.children.map((c2, c2idx) => {
                                    c2.date = item.title;
                                    c2.group = c1.title;
                                    c2.isChecked = c2idx === 0 && c1idx === 0 && idx < 2;
                                    return c2;
                                });

                                return c1;
                            });

                            return item;
                        });

                        this.setResearch({ response: modifiedResearch, key: value?.key });
                    });
                }
            });

            return result;
        },
        loadActiveResearch(key) {
            dispatch.settingsResearch.setActiveResearch(key);
        },
        async updateResearch({ key, callback }, rootState) {
            const currentResearch = rootState.settingsResearch.research[key];
            const newResearch = callback([...currentResearch]);

            this.setResearch({ key, response: newResearch });
            await dispatch.settings.setGisTypeVisible(key);
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        async updateDisplayData(payload, rootState) {
            const { activeResearch, selectedWell } = rootState.settingsResearch;

            await dispatch.settings.getVisibleGisCodes({ id: [selectedWell.id], key: selectedWell.key });
            const openedGisItems = await dispatch.settings.getDataFromState({ param: 'openedGisItems' });

            const keys = [];

            const filteredArr = cloneDeep(activeResearch)
                .map(item => {
                    item.children = item.children
                        ?.map(c1 => {
                            if (c1.children) {
                                c1.children = c1.children.filter(c2 => openedGisItems.includes(c2.code));
                                if (c1.children.length > 0) {
                                    const arr = [item.key, c1.key, ...c1.children.map(c2 => c2.key)];
                                    keys.push(...arr);
                                    return c1;
                                }
                            }
                        })
                        .filter(item => item);

                    return item;
                })
                .filter(item => item.children?.length > 0);

            dispatch.settingsResearch.setExpandedKeys(keys);
            dispatch.settingsResearch.setDisplayData(filteredArr);
        },
        addExpandedKey(key, rootState) {
            dispatch.settingsResearch.setExpandedKeys([...rootState.settingsResearch.expandedKeys, key]);
        },
        removeExpandedKey(key, rootState) {
            dispatch.settingsResearch.setExpandedKeys(
                rootState.settingsResearch.expandedKeys.filter(item => item !== key)
            );
        },
    }),
};

function createError(msg, info = {}) {
    const error = new Error();
    error.message = msg;
    error.info = info;
    return error;
}

export default researchModel;
